function getOptions (inter) {
  /*
    This gets the meta information from the event and add it
    to the
   */
  return {
    context: {
      traits: {
        gclid: window.analyticsDataLayer.gclid,
      },
      userAgent: navigator.userAgent
    },
    integrations: inter
  };
}

function updateProperties (rawData) {
  /*
    This will update the properties and including the
    localisation elements.
   */
  var data = rawData;
  Object.assign(data, window.analyticsDataLayer.testTags);
  return data;
}

export function postTrackEvent(eventName, valueData, integrations) {
  /*
   * This will post the analytics event to analytics and will take the
   * value data then combine it to the page data.
   */
  if (!valueData) {
    valueData = {};
  }

  if (!integrations) {
    integrations = {
      All: true
    };
  }

  if (window.rudderanalytics) {
    var properties = updateProperties(valueData);
    var options = getOptions(integrations);
    window.rudderanalytics.track(eventName, properties, options);
  } else {
    saveEvent(eventName, valueData, integrations);
  }

  // remove the event listener before adding it again to avoid duplicate events
  window.removeEventListener('message', postSavedEvents);
  window.addEventListener('message', postSavedEvents);
};

function saveEvent(eventName, valueData, integrations) {
  const storedEvents = localStorage.getItem('storedEvents');
  const event = {
    eventName: eventName,
    valueData: valueData,
    integrations: integrations
  };
  if (storedEvents) {
    let parsedStoredEvents = JSON.parse(storedEvents);
    parsedStoredEvents.push(event);
    localStorage.setItem('storedEvents', JSON.stringify(parsedStoredEvents));
  } else {
    localStorage.setItem('storedEvents', JSON.stringify([event, ]));
  }
}

function postSavedEvents (message) {
  if (message.data === 'analytics_loaded') {
    const storedEvents = localStorage.getItem('storedEvents');
    if (storedEvents) {
      let parsedStoredEvents = JSON.parse(storedEvents);
      parsedStoredEvents.forEach(event => {
        postTrackEvent(event.eventName, event.valueData, event.integrations);
      });
      localStorage.removeItem('storedEvents');
    }
  }
}

export function postIdentifyEvent(userId, traits) {
  /*
   * This will call the identify element of the Analytics
   */
  if (window.rudderanalytics) {
    window.rudderanalytics.identify(userId, traits);
  };
}

export function postAliasEvent(to, from, options, callback) {
  /*
   * This will call the alias function of the Analytics
   */
  if (window.rudderanalytics) {
    window.rudderanalytics.alias(to, from, options, callback);
  };
}
